import { Xml2html } from '../xml-html-converter/xml2html.class';

export class DomDummyNodeManager {
  public static DummyNodeClassName = 'dummyNode';
  public static DummyNodeBeforeFirstTagClassName = 'beforefirstTag';
  public static DummyNodeContent = String.fromCharCode(160);

  constructor() {}

  public static IsDummyNode(node: Node) {
    const asElem = node as Element;
    if (asElem && node.nodeType === Node.ELEMENT_NODE) {
      return asElem.classList.contains(DomDummyNodeManager.DummyNodeClassName);
    }
    return false;
  }

  public static IsBeforeFirstTagDummyNode(node: Node) {
    if (DomDummyNodeManager.IsDummyNode(node)) {
      const asElem = node as Element;
      if (asElem && node.nodeType === Node.ELEMENT_NODE) {
        return asElem.classList.contains(DomDummyNodeManager.DummyNodeBeforeFirstTagClassName);
      }
      return false;
    } else {
      return false;
    }
  }

  // get previos sibling - except dummy nodes
  public static getPreviousSibling(node: Node): Node {
    if (!node) {
      return undefined;
    }
    while (node) {
      node = node.previousSibling;
      if (node) {
        if (DomDummyNodeManager.IsDummyNode(node)) {
        } else {
          return node;
        }
      }
    }
    return undefined;
  }

  // get next sibling - except dummy nodes
  public static getNextSibling(node: Node): Node {
    if (!node) {
      return undefined;
    }
    while (node) {
      node = node.nextSibling;
      if (node) {
        if (DomDummyNodeManager.IsDummyNode(node)) {
        } else {
          return node;
        }
      }
    }
    return undefined;
  }

  // get children count - except dummy nodes
  public static getChildNodeCount(node: Node): number {
    if (!node) {
      return 0;
    }
    let count = 0;
    for (let i = 0; i < node.childNodes.length; i++) {
      if (!DomDummyNodeManager.IsDummyNode(node.childNodes[i])) {
        count++;
      }
    }
    return count;
  }

  // get first child - except dummy nodes
  public static getFirstChild(node: Node): Node {
    if (!node) {
      return undefined;
    }
    let first = node.firstChild as Node;
    while (DomDummyNodeManager.IsDummyNode(first)) {
      first = first.nextSibling;
    }
    return first;
  }

  // get last child - except dummy nodes
  public static getLastChild(node: Node): Node {
    if (!node) {
      return undefined;
    }
    let last = node.lastChild as Node;
    while (DomDummyNodeManager.IsDummyNode(last)) {
      last = last.previousSibling;
    }
    return last;
  }

  RemoveAllDummyNodes(node: Node, nodeDepth = 0): void {
    let children: Node[] = [];
    for (let i = 0; i < node.childNodes.length; ++i) {
      children.push(node.childNodes[i]);
    }

    // delete all dummy node children
    children.forEach(child => {
      if (DomDummyNodeManager.IsDummyNode(child)) {
        node.removeChild(child);
      }
    });

    children = [];
    for (let i = 0; i < node.childNodes.length; ++i) {
      children.push(node.childNodes[i]);
    }

    // update child nodes
    children.forEach(child => {
      this.RemoveAllDummyNodes(child, nodeDepth + 1);
    });
  }

  UpdateDummyNodes(node: Node, nodeDepth = 0) {
    const document = node.ownerDocument;
    const asElement = node as Element;

    const children: Node[] = [];
    for (let i = 0; i < node.childNodes.length; ++i) {
      children.push(node.childNodes[i]);
    }

    if (asElement && !DomDummyNodeManager.IsDummyNode(asElement) && !DomDummyNodeManager.IsDummyNode(asElement.parentElement)) {
      if (asElement.nodeType === Node.TEXT_NODE) {
        const before = asElement.previousSibling;
        if (before.nodeType === Node.TEXT_NODE) {
          // textnode after text node: dont insert dummy node!
        } else {
          if (!DomDummyNodeManager.IsDummyNode(before)) {
            asElement.parentNode.insertBefore(this.createDummyNode(document), asElement);
          }
        }
      }

      if (asElement.nodeType === Node.ELEMENT_NODE) {
        let firstChild = node.firstChild;
        if (!firstChild) {
          // create dummy node in empty tag
          node.appendChild(this.createDummyNode(document));
          firstChild = node.firstChild;
        }

        if (Xml2html.isNoClosingElement(node)) {
        } else {
          firstChild = node.firstChild;

          if (!firstChild) {
            // create dummy node in empty tag
            node.appendChild(this.createDummyNode(document));
            firstChild = node.firstChild;
          }

          // Insert a dummy node before the first child
          if (!DomDummyNodeManager.IsDummyNode(firstChild)) {
            if (firstChild) {
              node.insertBefore(this.createDummyNode(document), firstChild);
              firstChild = node.firstChild;
            } else {
              node.appendChild(this.createDummyNode(document));
            }
          }

          // Insert a dummy node after the last child
          let lastChild = node.lastChild;
          if (!DomDummyNodeManager.IsDummyNode(lastChild)) {
            node.appendChild(this.createDummyNode(document));
            lastChild = node.lastChild;
          }

          // Insert a dummy node before the first (dummy child) but optical in front of the node (to show the cursor in front of the node)
          if (nodeDepth > 0) {
            if (DomDummyNodeManager.IsDummyNode(firstChild) && !DomDummyNodeManager.IsBeforeFirstTagDummyNode(firstChild)) {
              const dummyNode = this.createDummyNode(document);
              dummyNode.classList.add(DomDummyNodeManager.DummyNodeBeforeFirstTagClassName);
              asElement.insertBefore(dummyNode, firstChild);
            }
          }
        }
      }
    }

    // update child nodes
    children.forEach(child => {
      this.UpdateDummyNodes(child, nodeDepth + 1);
    });
  }

  public createDummyNode(targetDocument: Document, content?: string): Element {
    const dummyNode = targetDocument.createElement('span');
    let dummy2TextNode;
    if (content === undefined) {
      dummy2TextNode = targetDocument.createTextNode(DomDummyNodeManager.DummyNodeContent);
    } else {
      dummy2TextNode = targetDocument.createTextNode(content);
    }
    dummyNode.classList.add(DomDummyNodeManager.DummyNodeClassName);
    dummyNode.appendChild(dummy2TextNode);
    return dummyNode;
  }
}
